// path: src/features/Sales/slices/modalSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  open: false,
  product: null,
};

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    openModal: (state, action) => {
      state.open = true;
      state.product = action.payload;
    },
    closeModal: (state) => {
      state.open = false;
      state.product = null;
    },
  },
});

export const { openModal, closeModal } = modalSlice.actions;
export default modalSlice.reducer;
